import axios, { AxiosRequestConfig } from '@sas/nova-core/axios';
import { getLogger } from '@sas/nova-core/logging';

import { HeaderAcceptItem } from '../../../catalog/foundation/model';

import {
  Collection,
  CollectionMediaTypeJSON,
  Link,
} from '../../../sonder/rest/representations/commons/commons';

import { AddTimeoutToRequest, DefaultRequestTimeoutSeconds } from './api';

// eslint-disable-next-line @sas/i18n/jsx-to-localize
const logger = getLogger('DataSelection');

// 85
export const GetLinkCollectionWithQuery = async (
  link: Link,
  query: Record<string, string>,
  cleanupURI: boolean
): Promise<[any[] | undefined, Error?]> => {
  let URI = link.uri;
  if (cleanupURI) {
    URI = removeURIParams(URI);
  }

  const requestConfig: AxiosRequestConfig = {
    method: 'GET',
    url: URI,
    headers: { Accept: CollectionMediaTypeJSON },
  };

  if (link.responseItemType) {
    requestConfig.headers = { ...requestConfig.headers, [HeaderAcceptItem]: link.responseItemType };
  } else if (link.itemType) {
    requestConfig.headers = {
      ...requestConfig.headers,
      [HeaderAcceptItem]: `${link.itemType}+json`,
    };
  }
  AddTimeoutToRequest(DefaultRequestTimeoutSeconds, requestConfig);
  logger.debug(`Preparing request to ${URI}`);
  let qStr = '';
  for (const [key, value] of Object.entries(query)) {
    qStr = `${qStr}${key}=${value},`;
    logger.debug(`Adding query parameter ${key}=${value} to URI ${URI}`);
    // request.AddQuery(key, value)
  }
  requestConfig.params = query;

  let response;
  try {
    response = await axios(requestConfig);
  } catch (error: any) {
    logger.debug('Request to ${URI} failed with an error ${error}');
    return [undefined, error];
  }

  logger.debug(`Request to ${URI} succeeded`);
  const collection = response.data as Collection<any>;

  logger.debug(`Request to ${URI} with query params ${qStr} succeeded`);
  return [collection.items, undefined];
};

// 266
const removeURIParams = (input: string): string => {
  const i = input.indexOf('?');
  if (i > -1) {
    return input.substring(0, i);
  }
  return input;
};
